<template>
  <div class="training-detail-introduction">
    <div class="training-title">培训班详情</div>
    <div class="item" @click="register">
      <div
        class="cover"
        :style="{ backgroundImage: `url(${detail.trainingCover})` }"
      ></div>
      <div class="order-info">
        <div class="order-name">
          <div class="name">{{ detail.trainingName }}</div>
          <div class="total-money">￥{{ detail.price }}</div>
        </div>
        <div class="order-time">
          <span>培训起止时间：</span> {{ detail.startTime }} ~
          {{ detail.endTime }}
        </div>
        <div class="bot-wrapper">
          <div @click.stop="register" class="btn">我要报名</div>
        </div>
      </div>
    </div>
    <div class="sub-title">培训班介绍</div>
    <div class="article-content">
      <img
        :src="item"
        :key="item"
        class="img"
        v-for="item in detailImageList"
      />
      <el-empty
        description="暂无介绍"
        v-if="!detailImageList.length"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { getTrainingDetaila } from "@/api/home";
export default {
  data() {
    return {
      uuid: this.$route.params.id,
      detail: {},
    };
  },
  computed: {
    isRealName() {
      return this.$store.getters["isRealName"];
    },
    isLogin() {
      return this.$store.getters["isLogin"];
    },
    detailImageList() {
      return this.detail.detailImageList || [];
    },
  },
  created() {
    const { id } = this.$route.params;
    getTrainingDetaila(id).then((res) => {
      this.detail = res;
    });
  },
  methods: {
    register() {
      if (!this.isLogin) {
        this.$store.commit("setShowType", "SIGN");
      } else {
        if (this.isRealName) {
          this.$router.push(`/register/${this.detail.uuid}`);
        } else {
          this.$store.commit("setRealNameFlag", true);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.training-detail-introduction {
  margin: 0.6rem auto 1rem;
  width: 13.1rem;
  .training-title {
    font-size: 0.2rem;
  }
  .item {
    display: flex;
    padding-top: 0.3rem;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
    border-top: 1px solid #e9e9e9;
    cursor: pointer;
    .cover {
      flex: 0 0 3.1rem;
      width: 3.1rem;
      height: 2rem;
      margin-right: 0.26rem;

      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .text-wrapper {
        width: 2.22rem;
        height: 0.81rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding: 0 0.26rem;
        background-image: url(../../assets/images/text-bg.png);
        background-size: 100% 100%;
        text-align: center;
      }
    }
    .order-info {
      flex: 1;
      padding-bottom: 0.06rem;
      .order-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.1rem;
        .name {
          font-size: 0.2rem;
          color: #333;
          font-weight: bold;
        }
        .total-money {
          font-size: 0.32rem;
          color: #eb1213;
          font-weight: bold;
        }
      }
      .order-time {
        font-size: 0.16rem;
        color: #999;
        margin: 0.37rem 0 0.35rem;
        span {
          color: #333;
          margin-right: 0.08rem;
        }
      }
    }
    .bot-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 0.24rem;
      border-top: 1px solid #e9e9e9;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.27rem;
        height: 0.4rem;
        line-height: normal;
        color: #fff;
        font-weight: 500;
        border-radius: 0.04rem;
        cursor: pointer;
        font-size: 0.16rem;
        background: linear-gradient(270deg, #ff6000, #ff8a00);
        margin-right: 0.2rem;
      }
    }
  }
  .sub-title {
    margin-top: 0.47rem;
    font-size: 0.18rem;
    font-weight: bold;
    color: #005ebd;
  }
  .page-title {
    margin-top: 0.24rem;
    text-align: center;
    font-size: 0.18rem;
  }
  .page-info {
    margin-top: 0.15rem;
    font-size: 0.16rem;
    text-align: center;
    color: #666666;
  }
  .article-content {
    margin-top: 0.23rem;
    font-size: 0.14rem;
    line-height: 0.33rem;
    .img {
      display: block;
      width: 100%;
      margin-bottom: 0.16rem;
    }
  }
}
</style>
